module.exports = __webpack_public_path__ + "img/AvatarKaty.f33fda4d.png";